<template lang="pug">
.d-flex.gap-5
  AppButton.min-w-unset(@click="moveBack")
    span.hi-thin-left-arrow
  AppButton.min-w-unset(@click="moveForward")
    span.hi-thin-right-arrow
</template>

<script>
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { mapInertiaProps } from '~/utils/inertia';

export default {
  computed: {
    ...mapInertiaProps({
      /* period can be: 'month', 'week', or 'day' */
      period: 'active_view',
      startDate: ({ start_date: startDate }) => dayjs(startDate),
      stopDate: ({ stop_date: stopDate }) => dayjs(stopDate),
    }),
  },
  mounted() {
    dayjs.extend(isoWeek);
  },
  methods: {
    moveBack() {
      this.$emit('change', ...this.previous(this.period));
    },
    moveForward() {
      this.$emit('change', ...this.forward(this.period));
    },
    previous(period) {
      if (period === 'month') {
        return [
          this.startDate.startOf(period).subtract(1, period).startOf(period),
          this.stopDate.endOf(period).subtract(1, period).endOf(period),
        ];
      }

      return [this.startDate.subtract(1, 'week'), this.stopDate.subtract(1, 'week')];
    },
    forward(period) {
      if (period === 'month') {
        return [this.startDate.startOf(period).add(1, period), this.stopDate.endOf(period).add(1, period)];
      }

      return [this.startDate.add(1, 'week'), this.stopDate.add(1, 'week')];
    },
  },
};
</script>
